import React from 'react';
import Webcam from "react-webcam";
import {
  Badge,
  Col,
  Row,
  Label,
  Form,
  Input,
  InputGroup,
  FormFeedback,
  UncontrolledAlert,
  UncontrolledTooltip,
} from "reactstrap"

import { Link } from "react-router-dom"

const WebcamComponent = ({isOpen, onClose, recibe, size} ) => {
  const webcamRef = React.useRef(null);

  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot(size);
    //console.log(imageSrc);
    recibe(imageSrc, "webcam");
    onClose();
  }, [webcamRef]);

  return (
    <>
    {isOpen ? (
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        width="100%"
      />
    ) : null}
      
      <Link onClick={capture}>captura</Link>
    </>
  );
};

export default WebcamComponent;
